const CarrierDefaultAccount = (userId, id, data) => async (
    dispatch,
    getState,
    { api, schema }
) => {
    return api.user.CarrierDefaultAccount(userId, id, data);
};

export default CarrierDefaultAccount;
